import angular from 'angular';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import ReactMarkdown from 'react-markdown';
import RemarkGfmAutolink from '@doxyme/remark-gfm-autolink';
class ReactMarkdownBridgeController {
    constructor($element) {
        this.$element = $element;
    }
    $onInit() {
        this.render();
    }
    $onChanges() {
        this.render();
    }
    $onDestroy() {
        unmountComponentAtNode(this.$element[0]);
    }
    render() {
        render(<ReactMarkdown remarkPlugins={RemarkGfmAutolink}>
        {this.source}
      </ReactMarkdown>, this.$element[0]);
    }
}
const ReactMarkdownBridge = {
    template: '<div></div>',
    bindings: { source: '<' },
    controller: ReactMarkdownBridgeController,
};
export default angular
    .module('doxy.common.components.reactMarkdown', [])
    .component('reactMarkdown', ReactMarkdownBridge).name;
